import React from "react"
import Showcase from "../components/Showcase"
import { View, Chart, Button } from "react-ame-components"

export class ChartBarExample extends React.Component {
  state = {
    labels: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho"],
    cores: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
    dataOptions: [
      {
        label: "Prata",
        data: [10, 20, 30, 40, 30, 15],
        color: "#c0c0c0",
      },
      {
        label: "Ouro",
        data: [90, 70, 30, 30, 40, 80],
        color: "#ffd700",
      },
    ],
  }

  handleButton = () => {
    const dataOptions = [
      {
        label: "Prata",
        data: [10, 90, 30, 90, 30, 15],
        color: "#c0c0c0",
      },
      {
        label: "Ouro",
        data: [10, 70, 30, 30, 40, 80],
        color: "#ffd700",
      },
    ]
    this.setState({ dataOptions })
  }

  render() {
    return (
      <Showcase
        title="Componente Chart.Bar"
        description="Este componente serve para exibir um gráfico de barra.">
        <Chart.Bar
          data={this.state.dataOptions}
          labels={this.state.labels}
          title="Número de vendas mensais"
          height={150}
        />
        <View paddingTop="medium">
          <Button
            onClick={this.handleButton}
            label="Alterar dados"
          />
        </View>
      </Showcase>
    )
  }
}
